import React from 'react';
import ChatbotWidget from './ChatbotWidget';

const Frame = ({ darkMode }) => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* First Section with ChatbotWidget */}
      <section className="min-h-screen">
        <ChatbotWidget darkMode={darkMode} />
      </section>
    </div>
  );
};

export default Frame;